import classNames from 'classnames';
import * as React from 'react';
import './style.css';

export interface PremiumContentInfoProps
  extends React.ComponentPropsWithoutRef<'section'> {
  /* empty*/
}

export interface PremiumContentInfoState {
  /* empty*/
}

export class PremiumContentInfo extends React.Component<
  PremiumContentInfoProps,
  PremiumContentInfoState
> {
  render() {
    const { props } = this;
    return (
      <section
        {...props}
        className={classNames('premium-content-info', props.className)}
      >
        <p>
          Signing up to Edge of Play gives you unlimited access to a broad range
          of content filmed with elite level clubs, coaches and players +
          hundreds of our grassroots coaching videos across all sections.
        </p>
        <br />
        <p>
          With an ever growing number of partner clubs and individuals, we are
          proud to be connecting the grassroots and elite levels of the game and
          look forward to providing you with exciting, new content each month.
        </p>
      </section>
    );
  }
}

export default PremiumContentInfo;



// WEBPACK FOOTER //
// ./src/app/components/Premium/PremiumPage/PremiumContentInfo/index.tsx